import { ButtonLink, usePageTitle } from 'slab'

import { CenteredLayout } from '../../pages/employer_onboarding/CenteredLayout'

export function NotFoundPage () {
  usePageTitle('Page not found')

  return (
    <CenteredLayout>
      <CenteredLayout.Header
        heading='Page not found'
        subheading="The page you requested doesn't exist. If you keep running into trouble, send us an email at support@thatch.com."
      />
      <CenteredLayout.Buttons>
        <ButtonLink variant='primary' href='/' size='large' width='auto'>Dashboard</ButtonLink>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
